
import React from 'react';
import VotePageView from './VotePageView';
import VotePageMobileView from './VotePageMobileView/VotePageMobileView';
import { votesService, categoriesService } from '../_services';
import {teamService } from '../_services/team.service';
import { history } from '../_helpers';
import { ROLES } from "../_constants/roles";
import { toast } from 'react-toastify';
import {getActivePollStatus} from '../PollManagement/Services/PollService';

const debounce = (fn, wait = 2000) => {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn(...args), wait);
    };
};

class VotePage extends React.Component {

    constructor() {
        super();
        this.rateChange = this.rateChange.bind(this);
        this.noteChange = this.noteChange.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onReorderTeams = this.onReorderTeams.bind(this);
        this.state = {
            width: window.innerWidth,
            categories: [],
            teams: [],
            loading: true,
            ownPage: false,
            judgeName: '',
            showBackToResults: true,
            isFrozen:false
        };

        this._inFlight = false;
        this._saveQueued = false;
        this.state = { ...this.state, saving: false };
        this.autoSave = debounce(() => this.requestSave(), 2000);
    }

    componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange);
    }

    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    };

    componentDidMount() {
        const { match: { params } } = this.props;
        var judgeId = params.judgeId;

        let user = JSON.parse(localStorage.getItem('user'));

        var isAdmin = user.roles.includes(ROLES.ADMIN);
        var isJudge = user.roles.includes(ROLES.JUDGE);

        if (!isAdmin && !isJudge) {
            history.push("/no-access");
            return;
        }

        var ownPage = (!judgeId) || (user.id == judgeId);
        var showBackToResults = isAdmin;

        var getCategories = categoriesService.getAll();
        var getVotes = votesService.getAll(judgeId);
        let getFreezeStatus=  getActivePollStatus();

        Promise.all([getCategories, getVotes, getFreezeStatus]).then(
            ([categories, votes, freezeStatus]) => {

                this.setState({
                    categories: categories,
                    teams: votes.teams,
                    loading: false,
                    ownPage: ownPage,
                    judgeName: votes.judgeName,
                    showBackToResults: showBackToResults,
                    isFrozen:freezeStatus.data.isScoreFrozen
                });

                console.log(votes.teams);
                console.log('frozen', this.state.isFrozen);
            },
            error => {
                toast("error!");
            }
        );

    }

    rateChange(teamId, categoryId, newScore) {
        let idx = this.state.teams.findIndex(team => team.id == teamId);
        let teams = [...this.state.teams];
        let team = { ...teams[idx] };

        let scoreIdx = team.scores.findIndex(score => score.categoryId == categoryId);
        var catScores = [...team.scores];
        var catScore = { ...catScores[scoreIdx] }
        catScore.score = newScore
        team.scores[scoreIdx] = catScore

        teams[idx] = team;
        this.setState({ teams: teams }, this.autoSave());
    }

    noteChange(teamId, newNotes) {
        let idx = this.state.teams.findIndex(team => team.id == teamId);

        if (idx === -1) {
            console.warn(`Team with ID ${teamId} not found.`);
            return;
        }

        let teams = [...this.state.teams];
        let team = { ...teams[idx] };

        team.notes = newNotes;
        teams[idx] = team;
        this.setState({ teams: teams }, this.autoSave());
    }

    onReorderTeams(sourceIndex, destinationIndex) {
        const teams = [...this.state.teams];

        const [removed] = teams.splice(sourceIndex, 1);
        teams.splice(destinationIndex, 0, removed);

        const updatedTeams = teams.map((team, index) => ({
            ...team,
            display_Order: index + 1
        }));

        this.setState({ teams: updatedTeams });

        if(!updatedTeams || !Array.isArray(updatedTeams)){
            console.log("Invalid teams data");
            return;
        }

        const payload= {
            teamIds: updatedTeams.map(x=>x.id)
        }

        teamService.updateTeamOrder(payload).then(()=>{
            toast("Order Changed.");
        })
        .catch(()=>{

        });
    }

    onSave = () => { this.requestSave(); };

    requestSave = () => {
        if (this._inFlight) {
            this._saveQueued = true;
            return;
        }

        this._inFlight = true;
        this.setState({ saving: true });

        const payload = this.state.teams;
        votesService.update(payload)
            .then((response) => {
                toast("Your score is being auto-saved.");
            })
            .catch((error) => {
                toast("Failed to auto-saved the score.");
            })
            .finally(() => {
                this._inFlight = false;
                this.setState({ saving: false });

                if (this._saveQueued) {
                    this._saveQueued = false;
                    this.requestSave();
                }
            });
    };

    render() {
        const { width } = this.state;
        const isMobile = width <= 930;

        const ViewComponent = isMobile ? VotePageMobileView : VotePageView;

        return <ViewComponent
            loading={this.state.loading}
            isMobile={isMobile}
            judgeName={this.state.judgeName}
            showBackToResults={this.state.showBackToResults}
            ownPage={this.state.ownPage}
            teams={this.state.teams}
            onNoteChange={this.noteChange}
            onSave={this.onSave}
            onRateChange={this.rateChange}
            onReorderTeams={this.onReorderTeams}
            categories={this.state.categories}
            isFrozen={this.state.isFrozen} />;
    }
}

export default VotePage;
